import React, { useEffect } from "react";
import TitlePage from "../../components/section/TitlePage/Titlepage";
import Tabs, { Tablist } from "../../components/ui/Tabs/Tabs";
import { useSetState } from "../../utils/hooks";
import Filter from "./Section/Filter";
import { InquiryTable } from "./Section/Inquiry1on1/inquiry-table";
import { useInquiryStats } from "../../api/inquiries/stats/use-inquiry-stats";
import { NoticeTable } from "./Section/Notice/notice-table";
import { EventTable } from "./Section/Event/event-table";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button/Button";
import { FAQTable } from "./Section/FAQ/faq-table";
import { VideoTable } from "./Section/Video/video-table";
import IntroModal from "./Section/Video/Section/IntroModal";
import { useUploadFile } from "../../api/helper/upload-file";
import Modal from "../../components/ui/Modal/Modal";
import { ReviewBB } from "./Section/Review/Review";
import Loading from "../../components/ui/Loading/Loading";
import ProductInquiryBB from "./Section/ProductInquiry/ProductInquiry";
import ProductInquiry1on1BB from "./Section/Inquiry1on1/1onInquiry";
import NoticeBB from "./Section/Notice/Notice";
import FAQBB from "./Section/FAQ/FAQ";
import EventBB from "./Section/Event/Event";
import VideoBB from "./Section/Video/Video";

const tabs = (data) => {
  return [
    {
      title: "상품 문의",
      id: 1,
      totalData:
        data?.numOfProductInquiry !== 0 ? data?.numOfProductInquiry : "0",
    },
    {
      title: "1:1 문의",
      id: 2,
      totalData: data?.numOfInquiry !== 0 ? data?.numOfInquiry : "0",
    },
    {
      title: "상품 리뷰",
      id: 3,
      totalData:
        data?.numOfProductReview !== 0 ? data?.numOfProductReview : "0",
    },
    {
      title: "공지사항",
      id: 4,
      totalData: data?.numOfNotice !== 0 ? data?.numOfNotice : "0",
    },
    {
      title: "FAQ",
      id: 5,
      totalData: data?.numOfFaq !== 0 ? data?.numOfFaq : "0",
    },
    {
      title: "이벤트",
      id: 6,
      totalData: data?.numOfEvent !== 0 ? data?.numOfEvent : "0",
    },
    {
      title: "동영상",
      id: 7,
      totalData: data?.numOfVideo !== 0 ? data?.numOfVideo : "0",
    },
  ];
};

function BulletinBoardPage() {
  const navigate = useNavigate();
  const { data } = useInquiryStats();
  const inquiryStats = data?.data;
  const [filter, dispatchFilter] = useSetState();
  const lastTab = localStorage.getItem("lastTab");
  const [currentTab, setCurrentTab] = React.useState(
    parseInt(lastTab) ? parseInt(lastTab) : 1
  );
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const [isSuccessUpload, setIsSuccessUpload] = React.useState(false);
  const defaultSearchBy =
    currentTab === 4 || currentTab === 6 ? "byTitle" : "byHospitalName";
  const [searchBy, setSearchBy] = React.useState(defaultSearchBy);
  const onChangeSearchBy = (id) => {
    setSearchBy(id);
  };
  const {
    mutate: uploadFile,
    isLoading,
    data: catalog,
    isSuccess,
    reset,
  } = useUploadFile();
  const [isUploadingCatalog, setIsUploadingCatalog] = React.useState(false);
  const [isResetted, setIsResetted] = React.useState(false);
  const [isResetting, setIsResetting] = React.useState(false);
  React.useEffect(() => {
    if (lastTab !== undefined || lastTab) {
      setCurrentTab(parseInt(lastTab));
    } else {
      setCurrentTab(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeTab = (id) => {
    setCurrentTab(id);
    setSelectedFilter({});
    setSearchBy(defaultSearchBy);
    localStorage.setItem("lastTab", id);
  };
  const onSubmitFilter = () => {
    setSelectedFilter(filter);
  };

  const onResetFilter = () => {
    setSelectedFilter({});
    setSearchBy(defaultSearchBy);
    setIsResetting(true);
    setIsResetted(true);
  };

  useEffect(() => {
    if (isResetting) {
      setTimeout(() => {
        setIsResetting(false);
      }, 500);
    }
  }, [isResetting]);

  return (
    <>
      <div>
        <TitlePage title="게시판 관리" />

        <Tabs
          onChangeTab={onChangeTab}
          currentTab={currentTab}
          tabs={tabs(inquiryStats)}
          tabWidth="w-24"
          titleTabPosition="justify-between"
        >
          <Tablist currentTab={currentTab} index={1}>
            <ProductInquiryBB />
          </Tablist>
          <Tablist currentTab={currentTab} index={2}>
            <ProductInquiry1on1BB />
          </Tablist>
          <Tablist currentTab={currentTab} index={3}>
            <ReviewBB />
          </Tablist>
          <Tablist currentTab={currentTab} index={4}>
            <NoticeBB />
          </Tablist>
          <Tablist
            childClassName="-mt-[16px]"
            currentTab={currentTab}
            index={5}
          >
            <FAQBB />
          </Tablist>
          <Tablist
            childClassName="-mt-[16px]"
            currentTab={currentTab}
            index={6}
          >
            <EventBB />
          </Tablist>
          <Tablist currentTab={currentTab} index={7}>
            <VideoBB />
          </Tablist>
        </Tabs>

        {isSuccessUpload && (
          <Modal
            isOpenFromOutside={isSuccessUpload}
            setIsOpenFromOutside={setIsSuccessUpload}
            description="등록된 파일로 카달로그가 업데이트 되었습니다."
            hasCancel={false}
            o
          />
        )}
      </div>
    </>
  );
}

export default BulletinBoardPage;
